import { createSlice } from '@reduxjs/toolkit';
import { getWeChatConfiguration, saveAccount, deleteAccount, resetStatus } from '../actions';

const initialState = {
  token: '',
  ipAddress: '',
  callbackURL: '',
  isConnecting: false,
  isDisconnecting: false,
  disconnectState: '',
  connectMessage: '',
  appId: '',
  appSecret: '',
  encryptKey: '',
};

const wechatSlice = createSlice({
  name: 'wechat',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(resetStatus, (state) => {
      state.disconnectState = '';
      state.connectMessage = '';
    });

    builder.addCase(getWeChatConfiguration.fulfilled, (state, action) => {
      state.token = action.payload.token;
      state.ipAddress = action.payload.ipAddresses;
      state.callbackURL = action.payload.callbackURL;
      state.appId = action.payload.appId;
      state.appSecret = action.payload.appSecret;
      state.encryptKey = action.payload.encryptKey;
    });

    builder.addCase(getWeChatConfiguration.rejected, (state, action) => {
      state.error = action.payload.error;
    });

    builder.addCase(saveAccount.pending, (state) => {
      state.isConnecting = true;
    });

    builder.addCase(saveAccount.fulfilled, (state, action) => {
      state.isConnecting = false;
      state.connectMessage = action.payload.apiResult.message;
    });

    builder.addCase(saveAccount.rejected, (state, action) => {
      state.isConnecting = false;
      state.connectMessage = action.payload.apiResult.message;
    });

    builder.addCase(deleteAccount.pending, (state) => {
      state.isDisconnecting = true;
    });

    builder.addCase(deleteAccount.fulfilled, (state, action) => {
      state.isDisconnecting = false;
      state.disconnectState = action.payload.apiResult.status;
      state.appId = '';
      state.appSecret = '';
      state.encryptKey = '';
    });

    builder.addCase(deleteAccount.rejected, (state, action) => {
      state.isDisconnecting = false;
      state.disconnectState = action.payload.apiResult.status;
    });
  },
});

export default wechatSlice;
